import React from 'react';
import { cn } from '../cn';

type TagProps = {
  /**
   * Accepts a string to be used as the tag label.
   */
  label: string | JSX.Element,
  /**
   * Sets styles according to usage.
   */
  status?: 'primary' | 'success' | 'warning' | 'error' | 'neutral' | 'accent',
  className?: string,
}

const Tag = ({ label, className, status = 'neutral' }: TagProps): JSX.Element => {
  return (
    <div className={cn([
      'py-0.5 px-1.5',
      'font-extrabold',
      status === 'primary' && [
        'bg-primary-lighter',
      ],
      status === 'success' && [
        'bg-success-lighter',
      ],
      status === 'warning' && [
        'bg-warning-lighter',
      ],
      status === 'error' && [
        'bg-error-lighter',
      ],
      status === 'neutral' && [
        'bg-neutral-200',
      ],
      status === 'accent' && [
        'bg-accent',
      ],
      'inline',
      'text-[14px] leading-[22px]',
      status === 'primary' && [
        'text-primary-darkest',
      ],
      status === 'success' && [
        'text-success-darkest',
      ],
      status === 'warning' && [
        'text-warning-darkest',
      ],
      status === 'error' && [
        'text-error-darkest',
      ],
      status === 'neutral' && [
        'text-neutral-800',
      ],
      status === 'accent' && [
        'text-white',
      ],
      className,
    ])}>
      <div>{label}</div>
    </div>
  );
};

export default Tag;
